import { VerticalSpacer } from '../';
import React from 'react';
import styled from 'styled-components';
import { Typography } from '../typography/Typography';
import { RichTextSpan } from '../text/RichTextSpan';
import { ArticleContainer } from './ArticleContainer.styles';
import { Button, CmsButtonProps } from '../buttons/Button';
import { GridContainer } from '../grid/GridContainer';

const ArticleCopyWrapper = styled.div`
    .paragraph {
        font-size: 20px;
        line-height: 36px;
        color: ${(p) => p.theme.palette.text.primary};
    }

    .raw-copy {
        iframe {
            max-width: 100%;
            margin: 24px 0;
        }
    }
`;

export interface ArticleCopyProps {
    title?: string;
    copy?: string;
    button?: CmsButtonProps;
    noGridContainer?: boolean;
}

export const ArticleCopy = ({
    title = '',
    copy = '',
    button = {},
    noGridContainer
}: ArticleCopyProps): JSX.Element => {
    const articleElem = (
        <ArticleContainer>
            <ArticleCopyWrapper className={`copy-wrapper`}>
                {title && (
                    <>
                        <Typography variant="h2">{title}</Typography>
                        <VerticalSpacer variant={'heading'} />
                    </>
                )}

                {copy && (
                    <div className="raw-copy">
                        <Typography variant="p">
                            <RichTextSpan richText={copy} />
                        </Typography>
                    </div>
                )}

                {button && button.label && (
                    <>
                        <VerticalSpacer variant={'eyebrow'} />
                        <Button type={button.type} href={button.href}>
                            {button.label}
                        </Button>
                    </>
                )}
            </ArticleCopyWrapper>
        </ArticleContainer>
    );
    return <>{noGridContainer ? articleElem : <GridContainer>{articleElem}</GridContainer>}</>;
};
